const ExamLockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4186_3235)">
      <path
        d="M6.01785 6.02597H4.00386V3.67632C4.00386 3.16484 4.10509 2.68798 4.30756 2.24575C4.51002 1.80353 4.78974 1.41459 5.14672 1.07892C5.50369 0.743257 5.92461 0.47952 6.40945 0.287712C6.8943 0.0959041 7.42444 -1.04167e-08 7.99986 0C8.51135 0 9.00419 0.0959041 9.47839 0.287712C9.95258 0.47952 10.3735 0.743257 10.7411 1.07892C11.1088 1.41459 11.4018 1.80353 11.6202 2.24575C11.8387 2.68798 11.9479 3.16484 11.9479 3.67632V6.02597H10.0138V4.12388C10.0138 3.45255 9.82737 2.93307 9.45441 2.56543C9.08145 2.1978 8.57529 2.01399 7.93593 2.01399C7.3605 2.01399 6.89697 2.1978 6.54532 2.56543C6.19367 2.93307 6.01785 3.45255 6.01785 4.12388V6.02597ZM12.907 6.98501C13.1947 6.98501 13.4424 7.08891 13.6502 7.2967C13.858 7.5045 13.9619 7.75225 13.9619 8.03996V12.995C13.9619 13.2827 13.9113 13.5518 13.8101 13.8022C13.7088 14.0526 13.5703 14.2711 13.3945 14.4575C13.2186 14.644 13.0109 14.7905 12.7711 14.8971C12.5313 15.0037 12.2676 15.0569 11.9799 15.0569H3.90796C3.62024 15.0569 3.35917 15.0037 3.12474 14.8971C2.89031 14.7905 2.69051 14.6494 2.52534 14.4735C2.36017 14.2977 2.2323 14.0926 2.14172 13.8581C2.05115 13.6237 2.00586 13.3733 2.00586 13.1069V8.03996C2.00586 7.75225 2.10709 7.5045 2.30956 7.2967C2.51202 7.08891 2.75711 6.98501 3.04482 6.98501H4.00386H6.01785H10.0138H11.9479H12.907Z"
        fill="black"
        fillOpacity="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4186_3235">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ExamLockIcon;
